import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-quotes-pending-approval',
    templateUrl: './quotes-pending-approval.component.html',
    styleUrls: ['./quotes-pending-approval.component.scss']
})
export class QuotesPendingApprovalComponent implements OnInit {

    constructor() { }

    @Input() chartType: string = 'donut';
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.quotesPendingApproval;
    chartSearchFilters: widgetFilters[] = [
        widgetFilters.customer,
        widgetFilters.class,
        widgetFilters.svcConst,
        widgetFilters.state, 
        widgetFilters.onCallRegion,
        widgetFilters.priority,
        widgetFilters.divisions
    ];

    ngOnInit() {
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }

}
